/* Ritter new site (Rachel 2026-10-24). PDP layer: short title, drawers, ?colour= preselect, mobile sticky add-to-cart.
   No cart logic of its own: the sticky button scrolls to and clicks the theme's real button, so the cart drawer,
   back-in-stock, Onward, Klarna and every pixel behave exactly as on the normal button. */
(function(){
  var root = document.querySelector('.rw-pdp'); if(!root) return;
  var h1 = root.querySelector('.product-block--title h1');
  if(h1){ var t = h1.textContent.trim().split(/\s[–—-]\s/)[0]; if(t) h1.textContent = t; }
  /* Drawers: product description (legal wording untouched) + collapsible rows, placed after the trust list. */
  var acc = document.createElement('div'); acc.className = 'rw-acc';
  function drawer(title, node){
    var d = document.createElement('details'); var s = document.createElement('summary'); s.textContent = title;
    var b = document.createElement('div'); b.className = 'rw-acc__body'; b.appendChild(node);
    d.appendChild(s); d.appendChild(b); acc.appendChild(d);
  }
  var desc = root.querySelector('.product-block--description');
  if(desc){ var inner = desc.querySelector('.product__description') || desc.firstElementChild; if(inner) drawer('Details', inner); }
  root.querySelectorAll('.product-block--collapsible-row').forEach(function(row){
    var b = row.querySelector('.accordion__button'); var body = row.querySelector('dd .content');
    if(b && body) drawer(b.textContent.trim(), body);
  });
  if(acc.children.length){
    var anchor = null;
    root.querySelectorAll('.product-block--text').forEach(function(x){ if(x.querySelector('ul')) anchor = x; });
    anchor = anchor || root.querySelector('.product-block--form');
    if(anchor && anchor.parentNode) anchor.parentNode.insertBefore(acc, anchor.nextSibling);
  }
  /* ?colour=Granite from the homepage colour strip: pick that colour in the variant picker. */
  try {
    var want = new URLSearchParams(location.search).get('colour');
    if(want){
      var hit = null;
      root.querySelectorAll('input[type=radio]').forEach(function(i){ if(!hit && i.value === want) hit = i; });
      if(hit){ hit.click(); }
      else { root.querySelectorAll('select').forEach(function(s){ for(var k=0;k<s.options.length;k++){ if(s.options[k].value === want){ s.value = want; s.dispatchEvent(new Event('change',{bubbles:true})); } } }); }
    }
  } catch(e){}
  /* Mobile sticky add-to-cart. */
  if(window.matchMedia('(min-width:769px)').matches) return;
  var btn = root.querySelector('[data-add-to-cart-trigger]'); if(!btn) return;
  var bar = document.createElement('div'); bar.className = 'rw-sticky';
  bar.innerHTML = '<div class="rw-sticky__t"><b></b><span></span></div><button type="button"></button>';
  bar.querySelector('b').textContent = h1 ? h1.textContent : '';
  document.body.appendChild(bar);
  var bb = bar.querySelector('button'), pr = bar.querySelector('span');
  function sync(){
    var lab = btn.querySelector('.text'); bb.textContent = btn.disabled ? 'Sold out' : (lab ? lab.textContent.trim() : 'Add to cart'); bb.disabled = btn.disabled;
    var p = root.querySelector('.modal_price .money, .modal_price [data-price], .modal_price'); if(p) pr.textContent = p.textContent.replace(/\s+/g,' ').trim().split(' ')[0];
  }
  bb.addEventListener('click', function(){ btn.scrollIntoView({behavior:'smooth', block:'center'}); setTimeout(function(){ if(!btn.disabled) btn.click(); }, 380); });
  new IntersectionObserver(function(es){ es.forEach(function(e){ bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }, {threshold:0}).observe(btn);
  new MutationObserver(sync).observe(root.querySelector('.product__information') || btn, {attributes:true, childList:true, subtree:true, characterData:true});
  sync();
})();